import styled from 'styled-components'

import { focusOutlineStyle } from '@totallymoney/ui/styles/focus'
import theme from '@totallymoney/ui/theme'

const RoundButton = styled.button<{
    isActivated?: boolean
}>`
    height: 48px;
    min-width: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${theme.space15};
    background-color: ${({ isActivated }) =>
        isActivated ? theme.grey20 : 'white'};

    border: ${({ isActivated }) =>
        isActivated
            ? `2px solid ${theme.indigo100}`
            : `1px solid ${theme.grey40}`};
    border-radius: ${theme.radii.borderRadius30};
    box-shadow: 0px 2px 8px rgba(8, 5, 28, 0.08);
    white-space: nowrap;
    cursor: pointer;

    &:hover,
    &:focus {
        border: ${({ isActivated }) =>
            `${isActivated ? '2px' : '1px'} solid ${theme.indigo100}`};
        ${focusOutlineStyle};
    }
`

export default RoundButton
